import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import UiIcon from "../../../ui/icons/uiIcon";
import {setIsSlabPricingEnabled} from "../../../../actions/sqftSlabFunctions";

const SqftLoadSlabPricingCheckbox = (props) => {
  const {isSlabPricingEnabled, setIsSlabPricingEnabled} = props;
  const [isActive, setActive] = useState(isSlabPricingEnabled);

  const checkboxClick = () => {
    setActive(!isActive);
    setIsSlabPricingEnabled(!isActive);
  };
  const isDisabled = false;
  const checkboxClasses = `ui-checkbox ui-checkbox--small${isActive ? " ui-checkbox--checked-svg" : ""}${isDisabled ? " ui-checkbox--disabled" : ""}`

  return (
    <button className="ui-checkbox-wrapper" onClick={checkboxClick} title={isActive ? "Slab pricing" : ""}>
      <div className={checkboxClasses}>
        <div className="ui-checkbox__svg">
          <UiIcon icon="checkmark"/>
        </div>
      </div>
      <span className={"ui-checkbox__label ui-checkbox__text" + (isDisabled ? " ui-checkbox__label--disabled" : "")}>
        <FormattedMessage id="sqft.popup.slab.slabPricing"/>
      </span>
    </button>
  )
};

const mapStateToProps = (store) => {
  const {assignQuotePopupSaveButtons} = store.assignQuoteState;
  const {isSlabPricingEnabled} = store.sqftSlabState;
  return {
    agreeEmailCheckbox: store.serverState.agreeEmailCheckbox,
    fabricatorData: store.fabricatorState,
    assignQuotePopupSaveButtons,
    isSlabPricingEnabled,
  };
};

const mapDispatchToProps = {
  setIsSlabPricingEnabled
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(SqftLoadSlabPricingCheckbox)
)
